import React from 'react';
import { Box } from '@mui/material';

import { VideosListItem } from './VideosListItem';

const styles = {
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center',
  },
};

export const VideosList = ({ data = [], onGetVideos }) => {
  return (
    <Box sx={styles.wrapper}>
      {data.length <= 0 && 'No Videos available'}
      {data.map((item) => (
        <VideosListItem key={item.id} data={item} onGetVideos={onGetVideos} />
      ))}
    </Box>
  );
};
